import React from 'react'
import './Error.css'
function Error() {
    return (
        <div className="container-fluid content-center errorimg">
            <div className="col-auto mb-3" >
                <div class= 'error'>
                    You don't have access to the requested page
                </div>
            </div>
        </div>
    )
}

export default Error
